import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import utils from "../../utils/utils";
import { dispatch } from "../index";

const initialState = {
  specialists: [],
  error: null,
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

const slice = createSlice({
  name: "specialist",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },

    getSuccess(state, action) {
      state.specialists = utils.sortAlphatically(action.payload, "name");
      const total = action.payload.length;
      let pages = Math.floor(total / state.limit);
      const remainder = total % state.limit;
      if (remainder !== 0) {
        pages += 1;
      }
      state.totalPages = pages;
      state.loading = false;
    },

    editSuccess(state, action) {
      state.loading = false;
    },

    setCurrentPage(state, action) {
      console.log(action.payload);
      state.currentPage = action.payload;
    },
  },
});

export default slice.reducer;

export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

export function getSpecialists() {
  return async () => {
    try {
      const result = await axios.get(`/specialists?size=1000`);
      dispatch(slice.actions.getSuccess(result.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addSpecialist(
  data,
  callback = () => {},
  errcallback = () => {}
) {
  return async () => {
    try {
      const result = await axios.post(`/specialists`, data);
      console.log("RES [addspecialists] ======> ", result.data.data);
      dispatch(slice.actions.addSuccess(result.data.data));
      callback();
    } catch (error) {
      console.log("ERR [addspecialists] =======> ", error);
      dispatch(slice.actions.hasError(error));
      errcallback();
    }
  };
}

export function deleteSpecialist(
  id = "",
  callback = () => {},
  errcallback = () => {}
) {
  const URL = `/specialists/${id}`;
  return async () => {
    try {
      const result = await axios.delete(URL);
      console.log("RES [deleteSpecialists] =======> ", result.data.data);
      callback();
      dispatch(slice.actions.deleteSuccess(result.data.data));
    } catch (error) {
      console.log("ERR [deleteSpecialists] =========> ", error);
      errcallback();
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editSpecialist(
  id,
  data,
  callback = () => {},
  errCallback = () => {}
) {
  return async () => {
    try {
      const result = await axios.put(`/specialists/${id}`, data);
      console.log("RES [editspecialists] =======> ", result?.data?.data);
      dispatch(slice.actions.editSuccess(result?.data?.data));
      callback();
    } catch (error) {
      console.log("ERR [editspecialists] ", error);
      dispatch(slice.actions.hasError(error));
      errCallback();
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}
